import $ from 'jquery';
import AOS from 'aos';
// import styleguide from './modules/style-guide.js';
// import accordions from './modules/accordions.js';
// import cards1Slider from './modules/cards1-slider.js';
// import cards from './modules/cards.js';
import menu from './modules/menu.js';
import highlightUnderlines from './modules/highlight-underlines.js';
import fancyapps from './modules/fancyapps.js';
import listingCardsSlider from './modules/listing-cards-slider.js';
import listingSlider from './modules/listing-slider.js';
import listingPeopleSlider from './modules/listing-people-slider.js';
import testimonialsSlider from './modules/testimonials-slider.js';
// import listingPeopleFacet from './modules/listing-people-facet.js';
import listingFaqCategoryNav from './modules/listing-faq-category-nav.js';
import singlePostSidebarNav from './modules/single-post-sidebar-nav.js';
import cards3EqualizeCopy from './modules/cards3-equalize-copy.js';
import heroScroll from './modules/hero-scroll.js';
import navBar from './modules/nav-bar.js';
import simpleSlider from './modules/simple-slider.js';
// import localization from './modules/localization.js';
// import mediaSliders from './modules/media-sliders.js';
// import scrollTo from './modules/scrollto.js';
// import sliders from './modules/sliders.js';
// import stats from './modules/stats.js';
// import testimonials from './modules/testimonials.js';
// import heroNavAriaLabels from './modules/hero-nav-aria-labels.js';
import pagerFacetActive from './modules/pager-facet-active.js';
import facetWpResultsAnnouncement from './modules/facetwp-results-announcement.js';
import subscribePrefill from './modules/subscribe-prefill.js';
// import svg from './modules/svg.js';

// Make sure that you init the styleguide first.
// styleguide.init();
// accordions.init();
// cards1Slider.init();
// cards.init();
AOS.init();

// AOS caches trigger positions at init; lazy-loaded images and sliders grow
// the page afterward, leaving elements low on long pages stuck hidden.
// Recalculate whenever the document height changes.
(() => {
	let refreshTimer;
	const queueRefresh = () => {
		clearTimeout(refreshTimer);
		refreshTimer = setTimeout(() => AOS.refresh(), 150);
	};
	window.addEventListener('load', queueRefresh);
	new ResizeObserver(queueRefresh).observe(document.body);
})();
menu.init();
// highlightUnderlines.init();
// heroNavAriaLabels.init();
fancyapps.init();
listingCardsSlider.init();
listingSlider.init();
listingPeopleSlider.init();
testimonialsSlider.init();
// listingPeopleFacet.init();
listingFaqCategoryNav.init();
singlePostSidebarNav.init();
cards3EqualizeCopy.init();
heroScroll.init();
navBar.init();
simpleSlider.init();
//localization.init();
// mediaSliders.init();
// scrollTo.init();
// sliders.init();
// stats.init();
// testimonials.init();
pagerFacetActive.init();
facetWpResultsAnnouncement.init();
subscribePrefill.init();
// svg.init();
